import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "./SiteChrome";

export default function EarthComparison() {
  const [position, setPosition] = useState(50);
  return (
    <section className="earth-story site-container">
      <div className="orbit-section-heading">
        <div>
          <p className="eyebrow">03 / A CHANGING PLANET</p>
          <h2>
            Same river.
            <br />
            <em>A different course.</em>
          </h2>
        </div>
        <p>
          The Indus River, Pakistan.
          <br />
          Seventeen years of change, seen from above.
        </p>
      </div>
      <figure className="earth-comparison">
        <div className="earth-comparison-images">
          <img
            src="/images/indus-2009.jpg"
            width="720"
            height="360"
            loading="lazy"
            decoding="async"
            alt="Landsat view of the Indus River in October 2009, with an oxbow lake where a river bend was cut off."
          />
          <img
            className="earth-before"
            src="/images/indus-1992.jpg"
            width="720"
            height="360"
            loading="lazy"
            decoding="async"
            alt="The same stretch of the Indus River in April 1992, before the bend was cut off."
            style={{ clipPath: `inset(0 ${100 - position}% 0 0)` }}
          />
          <span className="earth-image-date earth-date-before">
            27 APR 1992
          </span>
          <span className="earth-image-date earth-date-after">19 OCT 2009</span>
          <div
            className="earth-divider"
            style={{ left: `${position}%` }}
            aria-hidden="true"
          >
            <span>‹ ›</span>
          </div>
        </div>
        <div className="earth-slider">
          <label htmlFor="earth-comparison-range">
            Compare the years <span>Drag or use the arrow keys</span>
          </label>
          <input
            id="earth-comparison-range"
            type="range"
            min="0"
            max="100"
            value={position}
            onChange={(event) => setPosition(Number(event.target.value))}
            aria-valuetext={`${position}% of the 1992 image revealed`}
          />
          <div>
            <span>1992</span>
            <span>2009</span>
          </div>
        </div>
        <figcaption>
          <span>ARCHIVAL IMAGERY / LANDSAT 5</span>
          <a
            href="https://science.nasa.gov/earth/earth-observatory/indus-river-pakistan-43890/"
            target="_blank"
            rel="noopener noreferrer"
          >
            NASA Earth Observatory · Images by Robert Simmon ↗
          </a>
        </figcaption>
      </figure>
      <div className="earth-story-context">
        <h3>
          Change becomes clearer
          <br />
          with context.
        </h3>
        <div>
          <p>
            A bend in the lower Indus was cut off, leaving an oxbow lake. These
            Landsat images show how a river can reshape its surroundings over
            time. Differences in the fields also reflect the images’ different
            seasons.
          </p>
          <p>
            This is an archival visual story. The explorer’s river-flow module
            uses GloFAS model data.
          </p>
          <Link className="orbit-text-link" to="/monitor?module=flood">
            Explore modelled river flow <Icon name="arrow" size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
}
